import { useEffect, useState } from "react";
import { MessageSquareText, Users, Globe, AlertTriangle } from "lucide-react";

function StatCard({ title, value, icon: Icon, loading }) {
  return (
    <div className="bg-white border rounded-2xl p-5 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="text-sm text-slate-500">{title}</div>
        <div className="w-10 h-10 rounded-xl bg-[#4A9FD8]/10 flex items-center justify-center">
          <Icon className="text-[#4A9FD8]" size={20} />
        </div>
      </div>

      <div className="text-3xl font-extrabold mt-3">
        {loading ? "…" : value}
      </div>

      <div className="text-xs text-slate-500 mt-2">
        بيانات مباشرة من النظام
      </div>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    leads: 0,
    clients: 0,
    active_websites: 0,
    expiring: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/admin/dashboard.php")
      .then(res => res.json())
      .then(json => {
        if (json.ok && json.data) {
          setStats(json.data);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-extrabold">الإحصائيات</h2>
        <p className="text-sm text-slate-500">
          نظرة عامة على نشاط الاستضافة
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          title="طلبات تواصل معنا"
          value={stats.leads}
          icon={MessageSquareText}
          loading={loading}
        />

        <StatCard
          title="عدد العملاء"
          value={stats.clients}
          icon={Users}
          loading={loading}
        />

        <StatCard
          title="المواقع المفعّلة"
          value={stats.active_websites}
          icon={Globe}
          loading={loading}
        />

        <StatCard
          title="قريبة الانتهاء (30 يوم)"
          value={stats.expiring}
          icon={AlertTriangle}
          loading={loading}
        />
      </div>
    </div>
  );
}
